import { FileUpload } from "../../type";
import * as xlsx from 'xlsx';
export function generateUniqueId() {
  const timestamp = new Date().getTime();
  const random = Math.random() * 1000000;
  const uniqueId = `${timestamp}${random}`;

  return uniqueId;
}

export const getSheetNames = async (props: any): Promise<any[]> => {
  const { fileUpload, expectedDateFormate } = props;
  const isRowEmpty = (row: any[]): boolean => {
    return row.every((cell) => cell === null || cell === undefined || cell === "");
  };
  const normalizedDateFormat = expectedDateFormate
    ?.trim()
    ?.toLowerCase()
    ?.replace(/-/g, "/");
  console.log("normalizedDateFormat", normalizedDateFormat);

  const promises: Promise<any>[] = (fileUpload || []).map((fileItem: any) => {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      const fileName = fileItem.file?.name || "";
      const isCsv = fileName.toLowerCase().endsWith(".csv");

      reader.onload = (ev: any) => {
        const workbook = xlsx.read(ev.target.result, {
          type: isCsv ? "binary" : "array",
          raw: true,
          cellDates: true,
          dateNF: normalizedDateFormat
        });

        fileItem.totalSheet = workbook.SheetNames.map((sheetName: string) => {
          const sheet = workbook.Sheets[sheetName];
          const rawData: any[][] = xlsx.utils.sheet_to_json(sheet, {
            header: 1,
            defval: "",
            raw: false,
            dateNF: normalizedDateFormat
          });

          const trimmedRawData = rawData.filter((row, index) => {
            if (index === 0) return true;
            return !isRowEmpty(row);
          });

          console.log("trimmedRawData.slice(1)", trimmedRawData.slice(1));


          return {
            name: sheetName,
            sourceColumnList: trimmedRawData.length > 0 ? [trimmedRawData[0]] : [],
            rowData: trimmedRawData.slice(1),
          };
        });
        res(fileItem);
      };

      reader.onerror = (err) => {
        console.error("File reading error:", err);
        rej(err);
      };

      if (isCsv) {
        reader.readAsBinaryString(fileItem.file as any);
      } else {
        reader.readAsArrayBuffer(fileItem.file as any);
      }
    });
  });

  return Promise.all(promises);
};

export const getSheetData = async (props: any): Promise<FileUpload[]> => {
  const { fileUpload } = props;
  const promises: Promise<FileUpload>[] = fileUpload.map((fileItem: FileUpload) => {
    return new Promise((res, rej) => {
      let reader = new FileReader();
      reader.onload = (ev: ProgressEvent<FileReader>) => {
        const workbook = xlsx.read(ev.target?.result, { type: "binary" });
        fileItem.totalSheet = workbook.SheetNames.map((sheet) => {
          const workSheet = workbook.Sheets[sheet];
          let rows: string[][] = [];
          if (workSheet) {
            rows = xlsx.utils.sheet_to_json(workSheet, { header: 1 });
          }
          return {
            name: sheet,
            sourceColumnList: rows.length > 0 ? [rows[0]] : [],
            rowData: rows.slice(1),
          };
        });
        res(fileItem);
      };
      reader.readAsBinaryString(fileItem.file);
    });
  });
  return Promise.all(promises);
};

export const getFileData = async (props: any): Promise<any[]> => {
  const { fileUpload } = props;

  const promises: Promise<any>[] = fileUpload.map((fileItem: any) => {
    return new Promise((resolve, reject) => {
      const ext = fileItem.file.name.split('.').pop()?.toLowerCase();
      const reader = new FileReader();

      if (ext === 'csv') {
        reader.onload = () => {
          fileItem.fileType = 'csv';
          fileItem.totalSheet = [{
            name: fileItem.file.name,
          }];
          resolve(fileItem);
        };
        reader.readAsText(fileItem.file);
      } else if (ext === 'xlsx' || ext === 'xls') {
        reader.onload = (ev: ProgressEvent<FileReader>) => {
          try {
            const workbook = xlsx.read(ev.target?.result, { type: 'binary' });

            fileItem.fileType = 'xlsx';
            fileItem.totalSheet = workbook.SheetNames.map((sheet) => ({
              name: sheet,
            }));

            resolve(fileItem);
          } catch (error) {
            reject(error);
          }
        };
        reader.readAsBinaryString(fileItem.file);
      } else {
        reject(new Error('Unsupported file type'));
      }
    });
  });

  return Promise.all(promises);
};


export const getDate = (value: any) => {

  try {
    if (value != undefined && value != null) {
      return new Date(value);
    }

  } catch (error) {
    console.log("dateError", error)
  }
  return undefined;
};

export function parseDateStringToLocal(dateStr: string) {
  const [datePart, timePart] = dateStr.split(" ");
  const [day, month, year] = datePart.split("-").map(Number);
  const [hour, minute, second] = timePart.split(":").map(Number);

  return new Date(year, month - 1, day, hour, minute, second);
}

export const filterSelectedRows = (sheetRowData: any[], selectedRowIds: number[]): any[] => {
  return sheetRowData.filter((row: any[], index: number) => selectedRowIds.includes(index + 1));
};

export const generateCsvBlob = (filteredData: any[][], sourceColumns: any[]): Blob => {
  const csvContent = [
    sourceColumns.map((value: any) => escapeCsvValue(value)).join(","),
    ...filteredData.map((row) => row.map(escapeCsvValue).join(",")),
  ].join("\n");
  return new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
};

const escapeCsvValue = (value: any): string => {
  if (value === null || value === undefined) return "";
  let stringValue = String(value);
  if (stringValue.includes("\n") || stringValue.includes(",") || stringValue.includes("\"")) {
    stringValue = `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

export const updatePagination = (
  setCurrentPage: (page: number) => void,
  setPageSize: (size: number) => void
) => ({
  updateCurrentPageNo: (pageIndex: number) => {
    setCurrentPage(pageIndex);
  },
  updatePageLimit: (newPageSize: number) => {
    setPageSize(newPageSize);
    setCurrentPage(0);
  },
});
